export default __webpack_public_path__ + "static/media/featured-1.e51535f4.jpeg";